export default "__VITE_ASSET__1d00e507__"